import { useContentSelector } from '@wajeez-web/stores/content';

export const useContentEntityTypesLookups = () => {
  const data = useContentSelector(
    ({ contentEntityType }) => contentEntityType.lookups
  );

  const status = useContentSelector(
    ({ contentEntityType }) => contentEntityType.status
  );

  return { data, status };
};

export const useGetContentEntityTypeByIdMultilingual = () => {
  return useContentSelector(
    ({ contentEntityType }) => contentEntityType.byIdMultilingual
  );
};

export const useCreateContentEntityTypeMultilingual = () => {
  return useContentSelector(
    ({ contentEntityType }) => contentEntityType.createMultilingual
  );
};

export const useEditContentEntityTypeMultilingual = () => {
  return useContentSelector(
    ({ contentEntityType }) => contentEntityType.editMultilingual
  );
};

export const useGetContentEntityTypesDatatable = () => {
  return useContentSelector(
    ({ contentEntityType }) => contentEntityType.datatable
  );
};
